<div [formGroup]="form" class="form-grid">
  <div class="d-flex flex-column gap-2">
    <label for="firstName" class="form-input-label" i18n>First Name</label>
    <app-text-input
      formControlName="firstName"
      controlId="firstName"
      [error]="formSubmitted && form.controls.firstName.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.firstName.invalid"
      [customErrorMessages]="customErrorMessages.firstName"
      [errors]="form.controls.firstName.errors" />
  </div>
  <div class="d-flex flex-column gap-2">
    <label for="lastName" class="form-input-label" i18n>Last Name</label>
    <app-text-input
      formControlName="lastName"
      controlId="lastName"
      [error]="formSubmitted && form.controls.lastName.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.lastName.invalid"
      [customErrorMessages]="customErrorMessages.lastName"
      [errors]="form.controls.lastName.errors" />
  </div>
  <div class="d-flex flex-column gap-2">
    <label for="email" class="form-input-label" i18n>Email Address</label>
    <app-email-input formControlName="email" controlId="email" [error]="formSubmitted && form.controls.email.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.email.invalid"
      [customErrorMessages]="customErrorMessages.email"
      [errors]="form.controls.email.errors" />
  </div>
  <div class="d-flex flex-column gap-2">
    <label for="roleId" class="form-input-label" i18n>Role</label>
    <app-dropdown-input
      formControlName="roleId"
      controlId="roleId"
      [dropdowns]="roleDropdowns"
      [error]="formSubmitted && form.controls.roleId.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.roleId.invalid"
      [customErrorMessages]="customErrorMessages.roleId"
      [errors]="form.controls.roleId.errors" />
  </div>
</div>
